import React, { Component } from 'react';
import { Location, History } from 'history';
import * as Api from '../../lib/Api/';
import { Type } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';

import { Me } from '../../types';
import { Podcast } from '../../types';
import { SoundtrapPodcastModal } from './SoundtrapPodcastModal';
import { ReactComponent as NotificationIcon } from '../../svg/NotificationIcon.svg';
import { ReactComponent as SpotifyForPodcastersLogo } from '../../svg/SpotifyForPodcastersLogo.svg';
import { LoadingIndicator } from '../Shared/LoadingIndicator';
import { Backdrop, DialogAlert } from '@spotify-internal/encore-creator-web';

const ErrorContent = styled.div`
  display: flex;
  align-items: center;
  max-width: 660px;
  padding: 34px;

  svg {
    max-width: 120px;
    width: 100%;
    margin-right: 24px;
  }
`;

enum ValidationStatus {
  Idle,
  Validating,
  Success,
  Error,
  ClaimError,
  PodcastNotIngested,
}

interface State {
  validationStatus: ValidationStatus;
  podcastMetadata: null | Podcast;
}

interface Props {
  me: Me;
  loadMe(): void;
  soundTrapHash: string;
  history: History;
  location: Location;
}

export class AddSoundtrapPodcast extends Component<Props, State> {
  state: State = {
    validationStatus: ValidationStatus.Idle,
    podcastMetadata: null,
  };

  mounted = true;

  componentDidMount() {
    this.setState({ validationStatus: ValidationStatus.Validating });

    Api.validateSoundtrapHash(this.props.soundTrapHash)
      .then(response => {
        /* istanbul ignore else */
        if (this.mounted) {
          this.setState({
            validationStatus: ValidationStatus.Success,
            podcastMetadata: response,
          });
        }
      })
      .catch(error => {
        /* istanbul ignore else */
        if (this.mounted) {
          this.setState({
            validationStatus:
              error instanceof Api.PodcastStillProcessingError
                ? ValidationStatus.PodcastNotIngested
                : ValidationStatus.Error,
          });
        }
      });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    if (
      this.state.validationStatus === ValidationStatus.Idle ||
      this.state.validationStatus === ValidationStatus.Validating
    ) {
      return (
        <Backdrop center>
          <DialogAlert
            body={
              <div data-testid="validation-loading" style={{ textAlign: 'center' }}>
                <SpotifyForPodcastersLogo />
                <LoadingIndicator style={{ height: '38px' }} />
              </div>
            }
          />
        </Backdrop>
      );
    }

    if (
      this.state.validationStatus === ValidationStatus.Error ||
      this.state.validationStatus === ValidationStatus.ClaimError ||
      this.state.validationStatus === ValidationStatus.PodcastNotIngested
    ) {
      const title =
        this.state.validationStatus === ValidationStatus.PodcastNotIngested
          ? 'Spotify is processing your podcast.'
          : 'We weren’t able to get your podcast from Soundtrap.';

      return (
        <Backdrop center>
          <DialogAlert
            style={{
              width: 'auto',
            }}
            body={
              <ErrorContent data-testid="validation-failure">
                <NotificationIcon />
                <div>
                  <Type.h1 variant={Type.heading2}>{title}</Type.h1>
                  <Type.p variant={Type.body1}>
                    Please try again from Soundtrap in a few minutes.
                  </Type.p>
                </div>
              </ErrorContent>
            }
          />
        </Backdrop>
      );
    }

    return (
      <SoundtrapPodcastModal
        me={this.props.me}
        podcastMetadata={this.state.podcastMetadata as Podcast}
        loadMe={this.props.loadMe}
        history={this.props.history}
        location={this.props.location}
        onClaimError={
          /* istanbul ignore next */ () =>
            this.setState({ validationStatus: ValidationStatus.ClaimError })
        }
      />
    );
  }
}
